import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/store';
import { updatePolicy } from '../../../../../services/CaseManagementService/policySlice';

const categories = [
  { value: 'Arthroscopy', label: 'Arthroscopies' },
  { value: 'Cochlear', label: 'Cochlear Implants' },
  { value: 'ComputerAssisted', label: 'Computer Assisted' },
  { value: 'Inspire', label: 'Inspire Procedures' },
  { value: 'Mild', label: 'MILD Procedures' },
  { value: 'PainPump', label: 'Pain Pumps' },
  { value: 'Spine', label: 'Spine' },
  { value: 'Stimulators', label: 'Stimulators' },
  { value: 'TotalJoint', label: 'Total Joints' },
];

const PolicyCategoryEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const policy = useAppSelector((state) => state.policy.currentPolicy);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updatePolicy({ category: event.target.value }));
  };

  return (
    <TextField
      select
      label="Category"
      value={policy?.category || ''}
      onChange={handleChange}
      size="small"
      placeholder="Select policy category"
      sx={{ 
        width: 220,
        '& .MuiOutlinedInput-root': {
          backgroundColor: '#ffffff',
        }
      }}
    >
      <MenuItem value="">
        <em>Select Category</em>
      </MenuItem>
      {categories.map((category) => (
        <MenuItem key={category.value} value={category.value}>
          {category.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default PolicyCategoryEditor;
